module.exports = __webpack_public_path__ + "asset/dashboard--524530.png";